import { render, staticRenderFns } from "./ManagerListElement.vue?vue&type=template&id=315e523a&scoped=true"
import script from "./ManagerListElement.vue?vue&type=script&lang=js"
export * from "./ManagerListElement.vue?vue&type=script&lang=js"
import style0 from "./ManagerListElement.vue?vue&type=style&index=0&id=315e523a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e523a",
  null
  
)

export default component.exports